export const editTaskRoutesName = {
    editTask: "edit-task",
};
